export enum UsageTab {
  DATA = 'data',
  DASHBOARD = 'dashboard',
}
